<template>
  <GobSection id="casos" class="relative overflow-hidden z-10">
    <img
      :src="patron"
      alt=""
      aria-hidden="true"
      class="gob-patron-decorativo w-140 -right-20 -bottom-60 -z-1 opacity-75"
    />
    <div class="max-w-3xl">
      <h2 class="text-gob-5 leading-tight font-extrabold tracking-gob-tighter text-balance text-main -z-1">
        Entidades que ya gobiernan con Gob 24/7.
      </h2>
    </div>

    <ul class="mt-12 grid gap-6 md:grid-cols-2" role="list">
      <li
        v-for="caso in casos"
        :key="caso.entidad"
        class="flex flex-col rounded-gob-lg border border-[#DEE2E6] bg-surface p-7 shadow-soft sm:p-9 casos-hoover"
      >
        <img
          :src="caso.logo"
          :alt="`Logo de la ${caso.entidad}`"
          class="w-auto self-start object-contain"
          :class="caso.claseLogo"
          loading="lazy"
          decoding="async"
        />
        <h3 class="mt-8 text-gob-4 leading-tight font-black tracking-gob-tighter text-balance text-main">
          {{ caso.entidad }}
        </h3>
        <p class="mt-3 flex items-center gap-2 font-semibold text-main">
          <span class="size-2.5 shrink-0 rounded-full" :class="caso.claseMarca" aria-hidden="true"></span>
          {{ caso.solucion }}
        </p>
        <p class="mt-4 leading-relaxed text-[#495057]">{{ caso.texto }}</p>
      </li>
    </ul>

    <div class="mt-10">
      <GobButton to="/trayectoria" con-flecha>Ver la trayectoria completa</GobButton>
    </div>
  </GobSection>
</template>

<script>
import GobButton from '@/components/GobButton.vue'
import GobSection from '@/components/GobSection.vue'
import patron from '@/assets/home/casos-exito-patron.svg'
import { CASOS } from '@/data/trayectoria'

/**
 * HomeCasos
 * Casos de éxito como aval institucional: logo, entidad, solución implementada y alcance real.
 */
export default {
  name: 'HomeCasos',
  components: { GobButton, GobSection },
  data() {
    return { casos: CASOS, patron }
  }
}
</script>

<style>
/* Hover y tarjeta abierta: borde de 2 px en el color de la solución, sin mover el contenido. */
.casos-hoover:hover {
  border-color: var(--color-primary);
  box-shadow: 0 0 0 1px var(--color-primary);
}
</style>
